export default "__VITE_ASSET__DrAiP1wi__"